<div class='Home_features py-5 p-sm-5'>
  <div class='container'>
    <div class='d-flex flex-sm-row flex-column'>
      <div class='flex-grow-1'>
        <h3 class='text-center text-sm-left'>Individual</h3>
        <div class='Home_features_wrapper_col text-center p-3'>
          <label><img alt='' src='assets/images/retail/f1.png' /></label>
          <p>
            Individual-Retreva gives individual sales professionals
            everything they need to take their pipeline and sales to the next
            level. Retreva will help you get more meetings and eliminate
            tasks while helping you keep everything on track every step of the
            way.
          </p>
        </div>
      </div>
      <div class='flex-grow-1 mx-sm-5 pt-5 pt-sm-0'>
        <h3 class='text-center text-sm-left'>Team</h3>
        <div class='Home_features_wrapper_col text-center p-3'>
          <label><img alt='' src='assets/images/retail/f2.png' /></label>
          <p>
            Team-Small teams love Retreva. Teams enjoy the same benefits of
            individuals with the added benefits of contact de-duplication,
            domain management, enhanced reporting and more. Everything a sales
            team needs to boost sales.
          </p>
        </div>
      </div>
      <div class='flex-grow-1 pt-5 pt-sm-0'>
        <h3 class='text-center text-sm-left'>Enterprise</h3>
        <div class='Home_features_wrapper_col text-center p-3'>
          <a href='/enterprise.html'>
            <img alt='' src='assets/images/retail/f3.png' />
          </a>
          <p>
            Enterprise-Wondering how your existing email marketing and CRM
            technology will work with Retreva? Our Enterprise version just
            may be the perfect fit. We easily integrate with your current
            infrastructure while solving one of the biggest problems in
            sales-prospecting!
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
